import { useQuery } from "@tanstack/react-query";
import { ApiClient, apiClient } from "../providers/ApiClient";
import { useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";

export function useApiClient() {
  const { basejumpToken } = useContext(AuthContext);
  return useQuery({
    queryKey: ["apiClient", basejumpToken],
    queryFn: () => {
      if (!basejumpToken) {
        throw new Error("basejumpToken is not defined");
      }
      return new ApiClient(apiClient.baseURL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${basejumpToken}`,
        },
      });
    },
    enabled: Boolean(basejumpToken),
  });
}
